/* eslint-disable no-param-reassign */
function dataTableDefinitions(el) {
	el.defKnowledgeAndOpgaver = [];
	el.columnsKnowledgeAndOpgaver = [
		{
			targets: 0,
			data(row) {
				return '<a class="o-search-result-list__table-link" href="' + row[4] + '" title="' + row[0] + '">'
					+ '<h3 class="o-search-result-list__table-header">' + row[0] + '</h3>'
					+ '<div class="o-search-result-list__table-meta">' + row[1] + '</div>'
					+ '<p class="o-search-result-list__table-manchet">' + row[2] + '</p>'
					+ '</a>'
					+ '<nav class="o-search-result-list__table-breadcrumb">' + row[3] + '</nav>';
			}
		}
	];

	// Listview. Used for:
	// News, Publications
	el.defList = [];
	el.columnsList = [
		{
			targets: 0,
			data(row) {
				return '<a class="o-search-result-list__table-link o-search-result-list__table-link--flex" href="' + row[3] + '" title="' + row[0] + '">'
					+ '<div class="o-search-result-list__image-container ' + row[5] + '"><img class="o-search-result-list__image" src=' + row[4] + ' alt=' + row[0] + ' /></div>'
					+ '<div class="o-search-result-list__text">'
					+ '<h3 class="o-search-result-list__table-header">' + row[0] + '</h3>'
					+ '<div class="o-search-result-list__table-meta">' + row[1] + '</div>'
					+ '<p class="o-search-result-list__table-manchet">' + row[2] + '</p>'
					+ '</div>'
					+ '</a>';
			}
		}
	];


	el.defReports = [
		{ className: 'o-search-result-standard__grid-8-3 o-search-result-standard__date', targets: [0] },
		{ className: 'o-search-result-standard__grid-8-3', targets: [1] },
		{ className: 'o-search-result-standard__grid-24-9', targets: [3, 2] },
		{ className: 'o-search-result-standard__grid-16-6', targets: [4] }
	];
	el.columnsReports = [
		{
			targets: 0,
			data: row => `<span class="datatable-responsive__header" title="${row[0]}">${el.settings.columnsHeader1}</span><span class="datatable-responsive__content">${row[0]}</span>`
		},
		{
			targets: 1,
			data: row => `<span class="datatable-responsive__header" title="${row[1]}">${el.settings.columnsHeader2}</span><span class="datatable-responsive__content">${row[1]}</span>`
		},
		{
			targets: 2,
			data: row => `<span class="datatable-responsive__header" title="${row[2]}">${el.settings.columnsHeader3}</span><span class="datatable-responsive__content">${row[2]}</span>`
		},
		{
			targets: 3,
			data: row => `<span class="datatable-responsive__header" title="${row[3]}">${el.settings.columnsHeader4}</span><span class="datatable-responsive__content">${row[3]}</span>`
		},
		{
			targets: 4,
			data: row => `<span class="datatable-responsive__header" title="${row[4]}">${el.settings.columnsHeader5}</span><span class="datatable-responsive__content">${row[4]}</span>`
		},
		{
			targets: 5,
			data: row => `<span class="datatable-responsive__header" title="${row[5]}">${el.settings.columnsHeader6}</span><span class="datatable-responsive__content">${row[5]}</span>`
		},
	];

	el.defHabilitet = [
		{ className: 'o-search-result-standard__grid-8-3 o-search-result-standard__date', targets: [0] },
		{ className: 'o-search-result-standard__grid-26', targets: [1] },
		{ className: 'o-search-result-standard__grid-26', targets: [2, 3] },
		{ className: 'o-search-result-standard__grid-16-6 o-search-result-standard--no-right-padding', targets: [4] }
	];
	el.columnsHabilitet = [
		{
			targets: 0,
			data: row => `<span class="datatable-responsive__header" title="${row[0]}">${el.settings.columnsHeader1}</span><span class="datatable-responsive__content">${row[0]}</span>`
		},
		{
			targets: 1,
			data: row => `<span class="datatable-responsive__header" title="${row[1]}">${el.settings.columnsHeader2}</span><span class="datatable-responsive__content">${row[1]}</span>`
		},
		{
			targets: 2,
			data: row => `<span class="datatable-responsive__header" title="${row[2]}">${el.settings.columnsHeader3}</span><span class="datatable-responsive__content">${row[2]}</span>`
		},
		{
			targets: 3,
			data: row => `<span class="datatable-responsive__header" title="${row[3]}">${el.settings.columnsHeader4}</span><span class="datatable-responsive__content">${row[3]}</span>`
		},
		{
			targets: 4,
			data: row => `<span class="datatable-responsive__header">${el.settings.columnsHeader5}
					</span><span class="datatable-responsive__content">
						<a class="download-link" href="${row[5]}" title="${row[4]}" target="_blank">
							<span class="a-icon m-link-icon__icon download-link__icon"><svg class="a-icon__asset"><use xlink:href="#download_icon_circle" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg></span>
							${row[4]}
						</a>
					</span>`
		},

	];

	el.defPools = [
		{ className: 'o-search-result-standard__grid-30 o-search-result-standard__colored-text', targets: [0] },
		{ className: 'o-search-result-standard__grid-15', targets: [1, 2] },
		{ className: 'o-search-result-standard__grid-15 o-search-result-standard__date', targets: [3, 4] },
	];
	el.columnsPools = [
		{
			targets: 0,
			data: row => `<a href="${row[5]}" title="${row[0]}"><span class="datatable-responsive__header">${el.settings.columnsHeader1}</span><span class="datatable-responsive__content">${row[0]}</span></a>`
		},
		{
			targets: 1,
			data: row => `<span class="datatable-responsive__header" title="${row[1]}">${el.settings.columnsHeader2}</span><span class="datatable-responsive__content">${row[1]}</span>`
		},
		{
			targets: 2,
			data: row => `<span class="datatable-responsive__header" title="${row[2]}">${el.settings.columnsHeader3}</span><span class="datatable-responsive__content">${row[2]}</span>`
		},
		{
			targets: 3,
			data: row => `<span class="datatable-responsive__header" title="${row[3]}">${el.settings.columnsHeader4}</span><span class="datatable-responsive__content">${row[3]}</span>`
		},
		{
			targets: 4,
			data: row => `<span class="datatable-responsive__header" title="${row[4]}">${el.settings.columnsHeader5}</span><span class="datatable-responsive__content">${row[4]}</span>`
		}
	];

	el.defEvents = [
		{ className: 'o-search-result-events__title', targets: [0] },
		{ className: 'o-search-result-events__manchet', targets: [1] },
		{ className: 'o-search-result-events__date', targets: [2] },
		{ className: 'o-search-result-events__time', targets: [3] },
		{ className: 'o-search-result-events__location', targets: [4] },
	];
	el.columnsEvents = [
		{
			targets: 0,
			data: row => `<a href="${row[5]}" title="${row[0]}">${row[0]}</a>`
		},
		{
			targets: 1,
			data: row => row[1]
		},
		{
			targets: 2,
			data: row => `<div class="o-search-result-events__list-item" title="${row[2]}"><span class="a-icon">
				<svg class="a-icon__asset">
					<use xlink:href="#Date_icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
				</svg>
			</span>${row[2]}</div>`
		},
		{
			targets: 3,
			data: row => `<div class="o-search-result-events__list-item" title="${row[3]}"><span class="a-icon">
				<svg class="a-icon__asset">
					<use xlink:href="#Time_icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
				</svg>
			</span>${row[3]}</div>`
		},
		{
			targets: 4,
			data: row => `<div class="o-search-result-events__list-item o-search-result-events__list-item--last" title="${row[4]}"><span class="a-icon">
				<svg class="a-icon__asset">
					<use xlink:href="#Location_icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
				</svg>
			</span>${row[4]}</div>`
		},
	];

	el.defPhonebook = [
		{ className: 'o-search-result-phonebook__name', targets: [0] },
		{ className: 'o-search-result-phonebook__title', targets: [1] },
		{ className: 'o-search-result-phonebook__department', targets: [2] },
		{ className: 'o-search-result-phonebook__phone', targets: [3] },
		{ className: 'o-search-result-phonebook__mail', targets: [4] },
	];
	el.columnsPhonebook = [
		{
			targets: 0,
			data: row => `<a href="${row[5]}" title="${row[0]}">${row[0]}</a>`
		},
		{
			targets: 1,
			data: row => row[1]
		},
		{
			targets: 2,
			data: row => row[2]
		},
		{
			targets: 3,
			data: row => `<div class="o-search-result-phonebook__list-item"><span class="a-icon">
				<svg class="a-icon__asset" role=""button" aria-label="Telefon ikon">
					<use xlink:href="#SST_Telephone" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
				</svg>
			</span><a href="tel:${row[3]}" title="${row[3]}">${row[3]}</a></div>`
		},
		{
			targets: 4,
			data: row => `<div class="o-search-result-phonebook__list-item o-search-result-phonebook__list-item--last"><span class="a-icon">
				<svg class="a-icon__asset" role="button" aria-label="Brev ikon">
					<use xlink:href="#SST_Emailadress" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
				</svg>
			</span><a href="mailto:${row[4]}" title="${row[4]}">${row[4]}</a></div>`
		},
	];
}

export default dataTableDefinitions;
